// src/pages/OrderConfirmation.jsx
import { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    CircularProgress,
    Divider,
    Grid,
    Button,
    useMediaQuery,
    Avatar
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const API_URL = `http://192.168.1.248:3103/api`;

const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

export default function OrderConfirmation() {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');

    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API_URL}/orders/${orderId}`);
                setOrder(res.data);
                console.log(res.data);
            } catch (e) {
                console.error('Failed to fetch order', e);
            } finally {
                setLoading(false);
            }
        })();
    }, [orderId]);

    if (loading) {
        return (
            <Box textAlign="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (!order) {
        return (
            <Box textAlign="center" mt={4}>
                <Typography variant="h6" color="error">
                    Order not found.
                </Typography>
            </Box>
        );
    }

    const { items, total, placedAt, SONumber } = order;

    return (
        <Box p={isMobile ? 2 : 4} maxWidth="900px" mx="auto">
            <Paper elevation={6} sx={{ p: isMobile ? 3 : 4, borderRadius: 3, bgcolor: '#fefefe' }}>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                        <Avatar sx={{ bgcolor: 'success.main', width: 56, height: 56 }}>
                            <CheckCircleIcon fontSize="large" />
                        </Avatar>
                    </Grid>
                    <Grid item xs>
                        <Typography variant="h5" fontWeight={600}>
                            Your order is confirmed!
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Order <strong>#{SONumber || orderId}</strong> placed on <strong>{formatDate(placedAt)}</strong>
                        </Typography>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Items in your order
                </Typography>

                <Box maxHeight={300} overflow="auto">
                    {items.map((it, idx) => {
                        const qty = parseFloat(it.qty || 0);
                        const rate = parseFloat(it.rate || 0);
                        return (
                            <Paper key={idx} variant="outlined" sx={{ mb: 2, p: 2, borderRadius: 2 }}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={8}>
                                        <Typography fontWeight={500}>{it.productCode}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Qty: {qty} × ₹{rate.toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} textAlign="right">
                                        <Typography fontWeight={600}>₹{(qty * rate).toFixed(2)}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        );
                    })}
                </Box>

                <Divider sx={{ my: 3 }} />

                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                    <Typography variant="h6" fontWeight={600}>
                        Total
                    </Typography>
                    <Typography variant="h6" fontWeight={600}>
                        ₹{total.toFixed(2)}
                    </Typography>
                </Grid>

                <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    sx={{ mt: 2, py: 1.5, fontWeight: 600 }}
                    onClick={() => navigate('/main/orderDetail')}
                >
                    Continue Shopping
                </Button>
            </Paper>
        </Box>
    );
}